import { Slot } from "@radix-ui/react-slot";
import type React from "react";
import { tv } from "tailwind-variants";

import { cn } from "@/components/ui/utils";

const listItemStyles = tv({
  base: ["flex items-center h-10 outline-hidden", "hover:bg-muted/50 "],
  variants: {
    noBorder: {
      true: "border-b-0 hover:bg-inherit",
      false: "border-b last:border-b-0",
    },
  },
});

export type ListItemProps =
  | {
      asChild: true;
      children: React.ReactNode;
      className?: string;
      noBorder?: boolean;
      ref?: React.Ref<HTMLDivElement>;
    }
  | ({ asChild?: false; noBorder?: boolean } & React.ComponentProps<"div">);

export function ListItem({
  asChild,
  children,
  className,
  noBorder,
  ...props
}: ListItemProps) {
  const Comp = asChild ? Slot : "div";
  return (
    <Comp {...props} className={listItemStyles({ noBorder, className })}>
      {children}
    </Comp>
  );
}

type ListItemSectionProps = React.ComponentProps<"div">;

export function ListItemLeft(props: ListItemSectionProps) {
  return (
    <div
      {...props}
      className={cn(
        ["flex items-center flex-1 px-3 gap-2 min-w-0"],
        props.className,
      )}
    />
  );
}

export function ListItemRight(props: ListItemSectionProps) {
  return (
    <div
      {...props}
      className={cn("flex items-center shrink-0 px-3 gap-2", props.className)}
    />
  );
}

export function ListItemActions(props: ListItemSectionProps) {
  return (
    <div
      {...props}
      className={cn(
        ["flex items-center justify-end px-3 border-l gap-2 h-full"],
        props.className,
      )}
    />
  );
}
